import { render, staticRenderFns } from "./AnyTextAnswer.vue?vue&type=template&id=2bef7a17&scoped=true&"
import script from "./AnyTextAnswer.vue?vue&type=script&lang=js&"
export * from "./AnyTextAnswer.vue?vue&type=script&lang=js&"
import style0 from "./AnyTextAnswer.vue?vue&type=style&index=0&id=2bef7a17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bef7a17",
  null
  
)

export default component.exports